import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { Component, Input, OnInit } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { Store } from '@ngxs/store';
import _ from 'lodash';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { PresentationType } from 'src/app/samwebDescription/samweb/settings/presentationType';
import { ChangeShowVertical } from 'src/app/store/dashboard/brick-wall/brick-settings/specific-brick-settings/toolbar-brick-settings/toolbar-brick-settings.actions';
import { ToolbarBrickSettingsState } from 'src/app/store/dashboard/brick-wall/brick-settings/specific-brick-settings/toolbar-brick-settings/toolbar-brick-settings.state';

import {
   AddNewActionToToolbar,
   ChangeActionOrderForToolbar,
   ChangeToolbarPresentation,
} from 'src/app/store/dashboard/brick-wall/brick-settings/specific-brick-settings/toolbar-settings/toolbar-settings.actions';
import { ToolbarSettingsState } from 'src/app/store/dashboard/brick-wall/brick-settings/specific-brick-settings/toolbar-settings/toolbar-settings.state';

@Component({
   selector: 'samweb-action',
   templateUrl: './action.component.html',
   styleUrls: ['./action.component.scss'],
})
export class ActionComponent implements OnInit {
   @Input()
   public brickInstanceId: string;

   @Input()
   public toolbarId: string;

   @Input()
   public isVerticalViewPossible = false;

   public presentationTypePossibleValues = PresentationType.values();

   public presentationType$: Observable<PresentationType>;

   public actionIds$: Observable<string[]>;

   public addTabIcon: IconDefinition = faPlus;

   public showVertical$: Observable<boolean>;

   constructor(private store: Store) {}

   ngOnInit(): void {
      this.actionIds$ = this.store.select(ToolbarSettingsState.getToolbarActionIdsFn).pipe(
         map((fn) => fn(this.brickInstanceId, this.toolbarId)),
         distinctUntilChanged((prev, curr) => _.isEqual(prev, curr))
      );
      this.presentationType$ = this.store.select(ToolbarSettingsState.getToolbarPresentationTypeFn).pipe(map((fn) => fn(this.brickInstanceId, this.toolbarId)));
      this.showVertical$ = this.store.select(ToolbarBrickSettingsState.getIsVerticalViewEnabled).pipe(map((fn) => fn(this.brickInstanceId)));
   }

   onDrop(event: CdkDragDrop<string[]>): void {
      if (event.previousIndex === event.currentIndex) {
         return;
      }
      this.store.dispatch(new ChangeActionOrderForToolbar(this.brickInstanceId, this.toolbarId, event.previousIndex, event.currentIndex));
   }

   addNewAction() {
      this.store.dispatch(new AddNewActionToToolbar(this.brickInstanceId, this.toolbarId));
   }

   changePresentationType(value: PresentationType) {
      this.store.dispatch(new ChangeToolbarPresentation(this.brickInstanceId, this.toolbarId, value));
   }

   changeShowVertical(showVertical: boolean) {
      this.store.dispatch(new ChangeShowVertical(this.brickInstanceId, showVertical));
   }
}
